import { motion } from 'framer-motion';

const partners = [
  { name: 'Google', logo: '/images/partners/google.png' },
  { name: 'AWS', logo: '/images/partners/aws.png' },
  { name: 'Leroy Merlin', logo: '/images/partners/leroy-merlin.png' },
  { name: 'Nebulas.ai', logo: '/images/partners/nebulas-ai.svg' },
];

export const TrustedPartners = () => {
  return (
    <section className="relative bg-[#0a0a0a] border-y border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center text-xs uppercase tracking-[0.25em] text-gray-500 mb-8"
        >
          Trusted by Industry Leaders
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 items-center justify-items-center"
        >
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="flex items-center justify-center h-12"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-[40px] md:max-h-[48px] w-auto object-contain brightness-0 invert opacity-50 hover:brightness-100 hover:invert-0 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
